import { string, object, date, number, addMethod } from "yup";

let loginSchema = object().shape({
  email: string().email(),
  password: string().trim().min(5),
});

export default loginSchema;
